import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { TokenAdminService } from 'src/app/core/token/token-admin.service';
import { AdminUserService } from 'src/app/core/user/admin-user.service';

import { LayoutUtilsService } from './layout-utils.service';

@Injectable()
export class InterceptService implements HttpInterceptor {
  constructor(
    private tokenAdminService: TokenAdminService,
    private adminUserService: AdminUserService,
    private layoutUtilsService: LayoutUtilsService
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const headers: any = {};

    if (this.tokenAdminService.hasToken()) {
      headers.Authorization = `Bearer ${this.tokenAdminService.getToken()}`;
    }

    const { hash } = window.location;
    const companyKey = hash.replace('#/', '').split('/')[0];

    if (companyKey.indexOf('-') !== -1) {
      headers['X-AUTH-TOKEN'] = companyKey;
    }

    if (this.adminUserService.tokenPermissionSubject.value) {
      headers['X-PERMISSION-TOKEN'] =
        this.adminUserService.tokenPermissionSubject.value;

      this.adminUserService.tokenPermissionSubject.next(null);
    }

    if (Object.keys(headers).length > 0) {
      request = request.clone({
        setHeaders: headers,
      });
    }

    return next.handle(request).pipe(
      tap(
        (event) => {
          if (event instanceof HttpResponse) {
            // console.log('all looks good');
            // http response status code
            // console.log(event.status);
          }
        },
        (err) => {
          if (
            (this.tokenAdminService.hasToken() && err.status === 401) ||
            err.status === 403
          ) {
            //this.adminUserService.logout();
            this.layoutUtilsService.showActionNotification({
              title: 'Acesso não autorizado',
              icon: 'error',
            });
          }

          if (
            this.tokenAdminService.hasToken() &&
            request.method === 'GET' &&
            (err.status.toString().substring(0, 1) === '5' ||
              (err.status.toString().substring(0, 1) === '4' &&
                err.status !== 401 &&
                err.status !== 403))
          ) {
            this.layoutUtilsService.showActionNotification({
              title: 'Houve um erro na leitura dos dados',
              icon: 'error',
            });
          }

          // if (err.status === 401 && request.url.indexOf('login') === -1) {
          //   setTimeout(() => {
          //     window.location.reload();
          //   });
          // }
        }
      )
    );
  }
}
